import { IActionAutoCompleteItem, ISearchResult } from '@patsnap/synapse_common_interface'
import { IAutoCompleteParams, ISearchTreeParams, ISearchTreeResult, ITreeAggregationItem, ITreeAggregationParams } from '../../types'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class DrugActionApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async searchTree(params: ISearchTreeParams): Promise<IHttpWrap<ISearchTreeResult>> {
    return this.http({
      url: this.getUrl('pharmsnap_webapi/1.0/action/tree/search'),
      data: params,
      method: 'POST',
      cache: true,
    })
  }

  async getAutocomplete(params: IAutoCompleteParams): Promise<IHttpWrap<IActionAutoCompleteItem[]>> {
    const { keywords, limit = 5, cancelToken } = params

    return this.http({
      method: 'GET',
      url: this.getUrl('discoveryls_common/1.0/action/autocomplete'),
      cache: true,
      cancelToken,
      params: {
        prefix: keywords,
        limit,
      },
    })
  }

  async getAdvanceTreeAggregation(params: ITreeAggregationParams): Promise<IHttpWrap<ISearchResult<ITreeAggregationItem>>> {
    return this.http({
      url: this.getUrl('pharmsnap_webapi/1.0/action/aggregation/tree'),
      data: params,
      method: 'POST',
      cache: true,
    })
  }
}
